import { render } from "./DataManualMode.vue?vue&type=template&id=5d8c8ba4&scoped=true"
import script from "./DataManualMode.vue?vue&type=script&lang=js"
export * from "./DataManualMode.vue?vue&type=script&lang=js"

import "./DataManualMode.vue?vue&type=style&index=0&id=5d8c8ba4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d8c8ba4"]])

export default __exports__